import React from 'react';
import classNames from 'classnames';
import { Information } from '../Information';
import { Navbar } from '../Navbar';
import { capitalize } from '../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ServiceProspectConfirmation = function ServiceProspectConfirmation(_ref) {
  var _provider$user;

  var providerService = _ref.providerService,
      provider = _ref.provider;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('max-w-full lg:max-w-screen-xl lg:mx-auto'),
    children: [/*#__PURE__*/_jsx(Navbar, {
      brandProps: {
        logo: {
          src: providerService && providerService.avatarUrl ? providerService.avatarUrl : '',
          alt: "".concat(providerService && providerService.name ? providerService.name : 'Service', " Logo")
        },
        classes: classNames({
          'display-none': !providerService || !providerService.avatarUrl
        }),
        styles: {
          width: '4rem',
          height: '4rem',
          borderRadius: '.5rem',
          objectFit: 'cover'
        },
        // eslint-disable-next-line
        onClick: function onClick() {}
      }
    }), /*#__PURE__*/_jsx("div", {
      className: classNames('bg-white mx-auto px2 w-fill md:w-1/3'),
      style: {
        zIndex: 1
      },
      children: /*#__PURE__*/_jsx("img", {
        src: "https://subkit-images.s3.amazonaws.com/images/mailbox_purple.svg",
        alt: "Category Illustration",
        className: "w-fill"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classNames('mx-auto px1 w-fill md:w-1/3'),
      children: /*#__PURE__*/_jsx(Information, {
        heading: "You're almost there",
        body: "Check your inbox to confirm your email address and finish signing up for messages from ".concat(capitalize(providerService === null || providerService === void 0 ? void 0 : providerService.name), " by ").concat(capitalize(provider === null || provider === void 0 ? void 0 : (_provider$user = provider.user) === null || _provider$user === void 0 ? void 0 : _provider$user.firstName)),
        classes: {
          container: 'center'
        },
        styles: {
          heading: 'text-3xl',
          body: 'text-sm'
        }
      })
    })]
  });
};